import {Repository, createRepository} from '@/repositories/Base/Repository'

class FileRepository extends Repository {
    endpoint = 'integration/file'

    getContentOfFile(params) {
        return this.$axios.post(`${this.endpoint}/content`, params)
    }

    getOrderFiles(orderId) {
        return this.$axios.get(`integration/monitor/automation/files/order/${orderId}`)
    }

    getReportFiles(reportId) {
        return this.$axios.get(`integration/monitor/automation/files/report/${reportId}`)
    }
}

export default new FileRepository()

export const create = createRepository(FileRepository)